import React, { useRef } from 'react';

import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const text = {
  fontSize: 14,
  fontFamily: 'lato',
};

const inputStyle = {
  width: '100%',
  padding: 2,
  borderRadius: '6px',
  borderWidth: 0,
  boderColor:'red'
};
const container = {
  flex: 1,
  justifyContent: 'space-between',
  alignItems: 'center',
};
const useStyles = makeStyles({
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
});
export const TextInput = (props) => {
  const classes = useStyles();
  const inputRef = useRef()
  const {
    title,
    wrapperstyle,
    containerstyles,
    inputTextStyle,
    type,
    inputType,
    inputStyle: customInputStyle,
    borderBox,
    error,
    inputProps,
    value,
    ...textFieldProps
  } = props;
console.log("props?.value",value)
  return (
    <div
      style={
        ({ display: type == 'row' ? 'flex' : 'block', ...container },
        wrapperstyle ? { ...wrapperstyle } : {})
      }
    >
    {title?  <p
        style={
          ({ text }, inputTextStyle ? { ...inputTextStyle, fontFamily: 'lato' } : { fontFamily: 'lato' })
        }
      >
       {title} 
      </p>:null}
      <div
        style={Object.assign(
          {
            height: '40px',
            backgroundColor: 'white',
            border: borderBox ? borderBox : '2px solid #ebebeb',
            borderRadius: '6px',
          },
          containerstyles ? containerstyles : {}
        )}
      >
       {type=='date'?
        <TextField
        InputLabelProps={{ shrink: true }}
        InputProps={{ classes, ...inputProps }}
        style={inputStyle}
        inputRef={inputRef}
        value={value}
        type="date"
        {...textFieldProps}
        isfullwidth=""
        onClick={ () => {
          inputRef.current.showPicker()
       } }
      />:
       <TextField
          InputLabelProps={{ shrink: true }}
          InputProps={{ classes, ...inputProps }}
          style={inputStyle}
          inputRef={inputRef}
          value={value}
          type={inputType ? customInputStyle : null}
          {...textFieldProps}
          isfullwidth=""
        />}
      </div>
      {error ? (
        <p style={{ marginTop: '5px', color: 'red', textAlign: 'right', marginTop: 10, fontFamily: 'lato' }}>
          {error}
        </p>
      ) : null}
    </div>
  );
};

{
  /*
Example.(type=row/column)
<div style={{width:'50%'}}>
<TextInput placeholder="Here" type="row" title={"Holding text deposite"}/>   
</div>
*/
}
